<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <template v-if="can('payment_cost')">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Basic Information </h5>
          <div>
            <div class="mb-3 row">
              <label for="corporateName" class="col-sm-2 col-form-label">Corporate Name</label>
              <div class="col-sm-10">
                <input type="text" v-model="form.corporate_name" class="form-control" id="corporateName">
                <v-errors :errors="errorFor('corporate_name')"></v-errors>
              </div>
            </div>
            <div class="mb-3 row">
              <label for="businessNumber" class="col-sm-2 col-form-label">Business Number</label>
              <div class="col-sm-10">
                <input type="text" v-model="form.business_name" class="form-control" id="businessNumber">
                <v-errors :errors="errorFor('business_name')"></v-errors>
              </div>
            </div>
            <div class="mb-3 row">
              <label for="corporateNumber" class="col-sm-2 col-form-label">Corporate Number</label>
              <div class="col-sm-10">
                <input type="text" v-model="form.corporate_number" class="form-control" id="corporateNumber">
                <v-errors :errors="errorFor('corporate_number')"></v-errors>
              </div>
            </div>
            <div class="mb-3 row">
              <label for="Industry" class="col-sm-2 col-form-label">Industry</label>
              <div class="col-sm-10">
                <input type="text" v-model="form.industry" class="form-control" id="Industry">
                <v-errors :errors="errorFor('industry')"></v-errors>
              </div>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="howToBill" class="col-sm-2 col-form-label">How to Bill</label>
            <div class="col-sm-10">
              <input type="text" class="form-control" id="howToBill" value="Receive by Email" disabled readonly>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="Email" class="col-sm-2 col-form-label">Email</label>
            <div class="col-sm-8">
              <input type="email" v-model="form.billing_email" class="form-control" id="Email">
              <v-errors :errors="errorFor('billing_email')"></v-errors>
            </div>
            <!-- <button type="button" class="col-sm-2 btn btn-primary btn-sm">Change Billing Email</button> -->
          </div>
          <div class="mb-3 row">
            <label for="billingAddress" class="col-sm-2 col-form-label">Billing Address</label>
            <div class="col-sm-8">
              <input type="text" v-model="form.billing_address" class="form-control" id="billingAddress">
              <v-errors :errors="errorFor('billing_address')"></v-errors>
            </div>
            <!-- <button type="button" class="col-sm-2 btn btn-primary btn-sm">Change</button> -->
          </div>
          <div class="mb-3 row">
            <label for="mobileNumber" class="col-sm-2 col-form-label">Mobile Number</label>
            <div class="col-sm-8">
              <input type="text" v-model="form.mobile_number" class="form-control" id="mobileNumber">
              <v-errors :errors="errorFor('mobile_number')"></v-errors>
            </div>
            <!-- <button type="button" class="col-sm-2 btn btn-primary btn-sm">Change</button> -->
          </div>
          <h5 class="common_subtitle pb_20  font_16p pt_20">Payment Information</h5>
          <div class="mb-3 row">
            <label for="paymentMethod" class="col-sm-2 col-form-label">Payment Method</label>
            <div class="col-sm-6">
              <select class="form-control" id="paymentMethod" v-model="form.customer_payment_method_id">
                <option value="">Select once</option>
                <option v-for="method in paymentMethods" :value="method.id" :key="`payment_method_${method.id}`">{{ method.name }}</option>
              </select>
              <v-errors :errors="errorFor('customer_payment_method_id')"></v-errors>
            </div>
            <div class="col-sm-4">
              <button type="button" class=" btn btn-secondary me-2" @click="openPaymentMethodListModal">View</button>

              <button type="button" class="btn btn-primary" @click="openModal()">+ Add New</button>
            </div>
          </div>
          <div class="form-check form-check-inline">
            <input type="checkbox" v-model="form.agree" class="form-check-input"  name="inlineRadioOptions" id="agree" value="1">
            <label class="form-check-label" for="agree">I agree to collect my personal information.</label>
            <v-errors :errors="errorFor('agree')"></v-errors>
          </div>
          <div class="my-3 ">
            <button class="btn btn-primary me-3" @click="updatePaymentCost">Update</button>
          </div>
        </template>
        <template v-else>
          <p>You do not have permission to view this content.</p>
        </template>
      </div>
    </div>

    <BaseModal
        v-if="isShowModal"
        :title="modalTitle"
        :closeModal="closeModal"
        size="modal_850p"
    >
      <PaymentMethodForm
          :closeModal="closeModal"
          :loadData="getPaymentMethods"
          :editId="editId"
      />
    </BaseModal>
    <BaseModal
        v-if="isShowPaymentsModal"
        title="Payment Methods"
        :closeModal="closePaymentMethodListModal"
        size="modal_850p"
    >
      <PaymentMethodList
          :closeModal="closePaymentMethodListModal"
          :loadData="getPaymentMethods"
          :editId="editId"
      />
    </BaseModal>

  </div>
</template>

<script>
import PaymentMethodForm from "@/views/account/PaymentMethodForm.vue";
import PaymentMethodList from "@/views/account/PaymentMethodList.vue";
import BaseModal from "@/components/BaseModal.vue";
import { useAbility } from '@casl/vue';

export default {
  name: "PaymentCost",
  components: {BaseModal, PaymentMethodForm, PaymentMethodList},
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
  data() {
    return {
      paymentMethods: [],
      form: {
        customer_payment_method_id: ''
      },
      isShowModal: false,
      isShowPaymentsModal: false,
      editId: false,
    }
  },
  computed: {
    modalTitle(){
      if (this.editId) {
        return 'Edit Payment Method';
      } else {
        return 'Add New Payment Method';
      }
    }
  },
  mounted(){
    this.getPaymentCost()
    this.getPaymentMethods()
  },
  methods: {
    getPaymentCost() {
      this.axios.get("/payment-cost").then(({ data }) => {
        this.form = data.data
      })
    },
    getPaymentMethods() {
      this.axios.get("/customer-payment-methods").then(({ data }) => {
        this.paymentMethods = data.data
        if (this.paymentMethods && this.paymentMethods?.length > 0) {
          let defaultMethod = this.paymentMethods.find((item) => item.is_default)
          if (defaultMethod && !this.form.customer_payment_method_id) {
            this.form.customer_payment_method_id = defaultMethod.id
          }
        }
      })
    },
    updatePaymentCost(){
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.put('/update-payment-cost', this.form).then(({ data }) => {
        if (data.success) {
          this.showSuccessMsg(data.message);
        } else {
          this.showFailMsg(data.message);
        }
      })
      .catch(({ response }) => {
          this.allErrors = response?.data?.errors
          this.showFailMsg(response?.data?.message);
      })
      .finally(() => {
        this.lyLoading = false;
      })
    },
    openModal(editId = null){
      this.editId = editId
      this.isShowModal = true;
    },
    closeModal(){
      this.isShowModal = false;
    },
    openPaymentMethodListModal(){
      this.isShowPaymentsModal = true;
    },
    closePaymentMethodListModal(){
      this.isShowPaymentsModal = false;
      this.getPaymentMethods()
    },
  }
}
</script>

<style scoped>

</style>